import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';
import { CerberusStatsFields } from '@hcs/types';

import { CerberusStatsListingStatsChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useZipListingStatsTimeSeries } from '../../hooks';
import { getIsRentalListingStatsField } from '../../utils';

interface ZipListingStatsLineChartProps {
  className?: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  zipcode: string;
  cerberusStatsField: CerberusStatsFields;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const ZipListingStatsChart = ({
  className,
  zipcode,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  cerberusStatsField,
  theme,
}: ZipListingStatsLineChartProps) => {
  const dataHcName = `zipcode-${cerberusStatsField}-chart`;
  const { data, isLoading } = useZipListingStatsTimeSeries({
    fromDate,
    toDate,
    zipcode,
  });
  const isRentalField = getIsRentalListingStatsField(cerberusStatsField);

  return (
    <CerberusStatsListingStatsChart
      dataHcName={dataHcName}
      className={className}
      cerberusStatsField={cerberusStatsField}
      isRentalField={isRentalField}
      isLoading={isLoading}
      theme={theme}
      // note that zip does not have rental listing data
      data={isRentalField ? null : data}
    />
  );
};
